webpackJsonp([14,145],{

/***/ 1302:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Chat_vue__ = __webpack_require__(3363);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73c31155_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Chat_vue__ = __webpack_require__(3980);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(3953)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-73c31155"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Chat_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73c31155_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Chat_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/views/chat-interconsultations/Chat.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-73c31155", Component.options)
  } else {
    hotAPI.reload("data-v-73c31155", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 2548:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ES_CURRENCY */
/* unused harmony export MX_CURRENCY */
/* unused harmony export PT_CURRENCY */
/* harmony export (immutable) */ __webpack_exports__["a"] = getCurrencyByDomain;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_domainExtensions__ = __webpack_require__(1266);


var ES_CURRENCY = '€';
var MX_CURRENCY = '$';
var PT_CURRENCY = '€';

function getCurrencyByDomain() {
    return window.location.href.includes(__WEBPACK_IMPORTED_MODULE_0__constants_domainExtensions__["b" /* MX_DOMAIN_EXTENSION */]) ? MX_CURRENCY : ES_CURRENCY;
}

/***/ }),

/***/ 2597:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(25);


var client = function client() {
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$api;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  isFirstAppointment: function isFirstAppointment(profId) {
    return client().get('appointments/isFirstAppointment', { profId: profId });
  },
  getAppointmentReport: function getAppointmentReport(appointmentId) {
    return client().get('/patientReportPDF', { params: { appointmentId: appointmentId } });
  },
  getAppointmentPrescription: function getAppointmentPrescription(appointmentId) {
    return client().get('/prescriptions/' + appointmentId, { responseType: 'blob' });
  },
  getNextPatientAppointments: function getNextPatientAppointments(hideLoadingIcon) {
    return client().get('/patients/appointments/next', { loading: !hideLoadingIcon });
  },
  getPastPatientAppointments: function getPastPatientAppointments(_ref) {
    var fromDate = _ref.fromDate,
        toDate = _ref.toDate,
        professionalName = _ref.professionalName,
        appointmentType = _ref.appointmentType;

    return client().get('/patients/appointments/past', { params: { fromDate: fromDate, toDate: toDate, professionalName: professionalName, appointmentType: appointmentType } });
  },
  getAppointmentDetails: function getAppointmentDetails(appointmentId) {
    return client().get('appointments/Chats/GetAppointmentDetails', { params: { appointmentId: appointmentId } });
  },
  cancelAppointment: function cancelAppointment(appointmentId, reason) {
    return client().post('PatientCancelationAppointment', { AppointmentId: appointmentId, Reason: reason });
  }
});

/***/ }),

/***/ 2656:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers__ = __webpack_require__(282);



var client = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$api;

/* harmony default export */ __webpack_exports__["a"] = ({
  getFiles: function getFiles() {
    var fileId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    return client.get(Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["a" /* path */])('files', fileId));
  },
  getFilesTags: function getFilesTags() {
    var isApp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    return client.get('fileTags', { params: { isApp: isApp } });
  },
  getImage: function getImage(fileId) {
    return client.get('files/downloadImage', { params: { id: fileId } });
  },
  markLinkAsReaded: function markLinkAsReaded(linkId) {
    return client.get('files/markLinkAsReaded', { params: { linkId: linkId } });
  }
});

/***/ }),

/***/ 2719:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(25);


var client = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$api;

/* harmony default export */ __webpack_exports__["a"] = ({
  getProfessionals: function getProfessionals(params, hideLoadingIcon) {
    return client.get('search/professionals', { params: params, loading: !hideLoadingIcon });
  },
  getCompaniesProfessionals: function getCompaniesProfessionals(params, hideLoadingIcon) {
    return client.get('search/companiesProfessionals', { params: params, loading: !hideLoadingIcon });
  },
  getCenters: function getCenters(params, hideLoadingIcon) {
    return client.get('search/centers', { params: params, loading: !hideLoadingIcon });
  },
  getCentersAndProfs: function getCentersAndProfs(params, hideLoadingIcon) {
    return client.get('search/centersAndProfessionals', { params: params, loading: !hideLoadingIcon });
  },
  getProfsByName: function getProfsByName(name) {
    return client.get('search/professionalsByName', { params: { name: name } });
  },
  getCentersByName: function getCentersByName(name) {
    return client.get('search/centersByName', { params: { name: name } });
  }
});

/***/ }),

/***/ 2927:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__ = __webpack_require__(18);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    BModal: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["_32" /* BModal */],
    BRow: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["_45" /* BRow */],
    'base-checkbox': function baseCheckbox() {
      return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 513));
    },
    'base-select': function baseSelect() {
      return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 509));
    },
    'base-button': function baseButton() {
      return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 124));
    }
  },
  props: {
    value: [Boolean],
    isBillable: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function data() {
    return {
      selectedBillableEntity: null,
      noChargeCheckboxValue: false,
      noChargeOptions: [],
      noChargeSelectedReason: null,
      billingEntities: []
    };
  },

  methods: {
    consolidate: function consolidate() {
      this.visible = false;
      if (this.isBillable && !this.selectedBillableEntity) {
        this.$store.dispatch('showDangerAlert', this.$t('consolidate-appointment-modal.must-select-billable-entity'));
      } else if (this.isBillable && this.noChargeCheckboxValue && !this.noChargeSelectedReason) {
        this.$store.dispatch('showDangerAlert', this.$t('consolidate-appointment-modal.must-specify-not-charge-reason'));
      } else {
        this.$emit('consolidate', { BillingEntityId: this.selectedBillableEntity, NoChargeReasonId: this.noChargeSelectedReason });
      }
    },
    noChargeToggled: function noChargeToggled() {
      var _this = this;

      if (!this.noChargeCheckboxValue && this.noChargeOptions.length === 0) {
        this.$api('NoChargeReasons').then(function (response) {
          _this.noChargeOptions = response.data.data;
        });
      }
    },
    loadBillableEntities: function loadBillableEntities() {
      var _this2 = this;

      if (this.billingEntities.length === 0) {
        this.$api('webapp/BillingEntities').then(function (response) {
          _this2.billingEntities = response.data.data;
        });
      }
    }
  },
  computed: {
    isVisible: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        this.$emit('input', val);
      }
    },
    noChargeSelectedReasonIsTechnicalType: function noChargeSelectedReasonIsTechnicalType() {
      return this.noChargeSelectedReason ? this.noChargeSelectedReason.value === 1 || this.noChargeSelectedReason.value === 4 : false;
    }
  }
});

/***/ }),

/***/ 2935:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(25);


var client = function client() {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$api;
};

/* harmony default export */ __webpack_exports__["a"] = ({
    notifyProfessionalDisabledTarifaPlus: function notifyProfessionalDisabledTarifaPlus(params) {
        return client().post('professionals/NotifyProfessionalDisabledTarifaPlus', params);
    },
    notifyPrevalidatedProfessional: function notifyPrevalidatedProfessional(params) {
        return client().post('professionals/NotifyProfessionalPrevalidated', params);
    },
    getProfPatients: function getProfPatients(name) {
        return client().get('professionals/GetProfessionalPatients', { params: { name: name } });
    }
});

/***/ }),

/***/ 3139:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConsolidateAppointmentModal_vue__ = __webpack_require__(2927);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72bd54cf_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConsolidateAppointmentModal_vue__ = __webpack_require__(3142);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(3140)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConsolidateAppointmentModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72bd54cf_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConsolidateAppointmentModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/webapp/shared/ConsolidateAppointmentModal.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-72bd54cf", Component.options)
  } else {
    hotAPI.reload("data-v-72bd54cf", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 3140:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3141);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("f8f9eb96", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-72bd54cf\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ConsolidateAppointmentModal.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-72bd54cf\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ConsolidateAppointmentModal.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 3141:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active,.slide-down-leave-active{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter,.slide-down-leave-to{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active,.slide-fade-left-leave-active{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter,.slide-fade-left-leave-to{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter,.fade-leave-to{opacity:0\n}\n.modal-content{-webkit-transition:all linear 2.5s;transition:all linear 2.5s\n}\n", ""]);

// exports


/***/ }),

/***/ 3142:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        centered: "",
        "cancel-disabled": "",
        "no-close-on-esc": "",
        "no-close-on-backdrop": "",
        "hide-header-close": "",
        title: _vm.$t("consolidate-modal.title")
      },
      on: { show: _vm.loadBillableEntities },
      scopedSlots: _vm._u([
        {
          key: "modal-footer",
          fn: function() {
            return [
              _c(
                "div",
                { staticClass: "w-100" },
                [
                  _c(
                    "base-button",
                    {
                      attrs: { white: "", shadow: "" },
                      on: { click: _vm.consolidate }
                    },
                    [_vm._v(_vm._s(_vm.$t("continue")))]
                  )
                ],
                1
              )
            ]
          },
          proxy: true
        }
      ]),
      model: {
        value: _vm.isVisible,
        callback: function($$v) {
          _vm.isVisible = $$v
        },
        expression: "isVisible"
      }
    },
    [
      _c("div", { staticClass: "text-center" }, [
        _vm.isBillable
          ? _c(
              "div",
              [
                _c("p", [
                  _vm._v(_vm._s(_vm.$t("consolidate-modal.charge-with-data")))
                ]),
                _vm._v(" "),
                _c("base-select", {
                  attrs: {
                    disabled: _vm.noChargeSelectedReasonIsTechnicalType,
                    placeholder: _vm.$t(
                      "consolidate-appointment-modal.select-billable-entity"
                    ),
                    options: _vm.billingEntities
                  },
                  model: {
                    value: _vm.selectedBillableEntity,
                    callback: function($$v) {
                      _vm.selectedBillableEntity = $$v
                    },
                    expression: "selectedBillableEntity"
                  }
                }),
                _vm._v(" "),
                _c(
                  "base-checkbox",
                  {
                    attrs: { onInput: _vm.noChargeToggled },
                    model: {
                      value: _vm.noChargeCheckboxValue,
                      callback: function($$v) {
                        _vm.noChargeCheckboxValue = $$v
                      },
                      expression: "noChargeCheckboxValue"
                    }
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.$t("consolidate-appointment-modal.no-charge")
                        ) +
                        "\n      "
                    )
                  ]
                ),
                _vm._v(" "),
                _c("base-select", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.noChargeCheckboxValue,
                      expression: "noChargeCheckboxValue"
                    }
                  ],
                  attrs: {
                    placeholder: _vm.$t(
                      "consolidate-appointment-modal.select-no-charge-reason"
                    ),
                    options: _vm.noChargeOptions
                  },
                  model: {
                    value: _vm.noChargeSelectedReason,
                    callback: function($$v) {
                      _vm.noChargeSelectedReason = $$v
                    },
                    expression: "noChargeSelectedReason"
                  }
                })
              ],
              1
            )
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-72bd54cf", esExports)
  }
}

/***/ }),

/***/ 3363:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_consultationTypes__ = __webpack_require__(1255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_colours__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_base_forms_BaseInput_vue__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_base_BaseDialog__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_bootstrap_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_base_buttons_BaseButton_vue__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ChatMessage_vue__ = __webpack_require__(3955);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__repositories_ChatRepository__ = __webpack_require__(1280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__repositories_ChipcardRepository__ = __webpack_require__(3963);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__constants_signalRCommands__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__constants_roles__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_webapp_shared_CancelAppointmentModal_vue__ = __webpack_require__(3964);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_webapp_shared_ConsolidateAppointmentModal_vue__ = __webpack_require__(3139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__AdministrativeChatModal_vue__ = __webpack_require__(3968);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ChatMessageInput_vue__ = __webpack_require__(3976);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


















/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    BaseInput: __WEBPACK_IMPORTED_MODULE_4__components_base_forms_BaseInput_vue__["default"],
    BaseDialog: __WEBPACK_IMPORTED_MODULE_5__components_base_BaseDialog__["default"],
    BIcon: __WEBPACK_IMPORTED_MODULE_6_bootstrap_vue__["C" /* BIcon */],
    BaseButton: __WEBPACK_IMPORTED_MODULE_7__components_base_buttons_BaseButton_vue__["default"],
    ChatMessage: __WEBPACK_IMPORTED_MODULE_8__ChatMessage_vue__["a" /* default */],
    ChatMessageInput: __WEBPACK_IMPORTED_MODULE_16__ChatMessageInput_vue__["a" /* default */],
    CancelAppointmentModal: __WEBPACK_IMPORTED_MODULE_13__components_webapp_shared_CancelAppointmentModal_vue__["a" /* default */],
    ConsolidateAppointmentModal: __WEBPACK_IMPORTED_MODULE_14__components_webapp_shared_ConsolidateAppointmentModal_vue__["default"],
    AdministrativeChatModal: __WEBPACK_IMPORTED_MODULE_15__AdministrativeChatModal_vue__["a" /* default */]
  },
  data: function data() {
    return {
      CHAT: __WEBPACK_IMPORTED_MODULE_2__constants_consultationTypes__["d" /* CHAT */],
      chats: [],
      userType: __WEBPACK_IMPORTED_MODULE_12__constants_roles__["f" /* PATIENT_ROLE */],

      showFinishModal: false,
      showCancelModal: false,
      showAdministrativeModal: false,

      showScrollBottomButton: false,

      SECONDARY: __WEBPACK_IMPORTED_MODULE_3__constants_colours__["l" /* SECONDARY */],
      PROFESSIONAL_ROLE: __WEBPACK_IMPORTED_MODULE_12__constants_roles__["h" /* PROFESSIONAL_ROLE */],
      PATIENT_ROLE: __WEBPACK_IMPORTED_MODULE_12__constants_roles__["f" /* PATIENT_ROLE */]
    };
  },

  watch: {
    '$store.state.signalr.commandReceived': function $storeStateSignalrCommandReceived(_ref) {
      var _this = this;

      var command = _ref.command,
          data = _ref.data;

      switch (command) {
        case __WEBPACK_IMPORTED_MODULE_11__constants_signalRCommands__["j" /* NEW_CHAT_MESSAGE */]:
          var dataSplitted = data.split(';');
          var appointmentId = parseInt(dataSplitted[0]);
          if (this.chatUserDetails.idAppointment !== appointmentId) {
            this.chats.find(function (x) {
              return x.idAppointment === appointmentId;
            }).numMessagesPendingRead += 1;
          } else {
            __WEBPACK_IMPORTED_MODULE_9__repositories_ChatRepository__["a" /* default */].getMessage(parseInt(dataSplitted[1])).then(function (response) {
              _this.chatMessages.push(response.data.data);
              _this.$store.commit('chat/incrementUnreadMessages');
              _this.$nextTick(function () {
                _this.$uiHelpers.scrollBottom(_this.$refs.messageList, true);
              });
            });
          }
          break;
        case __WEBPACK_IMPORTED_MODULE_11__constants_signalRCommands__["e" /* EDIT_CHAT_MESSAGE */]:
          var editDataSplitted = data.split(';');
          var editAppointmentId = parseInt(editDataSplitted[0]);
          if (this.chatUserDetails.idAppointment === editAppointmentId) {
            __WEBPACK_IMPORTED_MODULE_9__repositories_ChatRepository__["a" /* default */].getMessage(parseInt(editDataSplitted[1])).then(function (response) {
              _this.$store.commit('chat/editMessage', { msgId: parseInt(editDataSplitted[1]), msg: response.data.data });
            });
          }
          break;
        case __WEBPACK_IMPORTED_MODULE_11__constants_signalRCommands__["d" /* DELETE_CHAT_MESSAGE */]:
          var deleteDataSplitted = data.split(';');
          var deleteAppointmentId = parseInt(deleteDataSplitted[0]);
          if (this.chatUserDetails.idAppointment === deleteAppointmentId) {
            this.$store.commit('chat/deleteMessageFromChat', parseInt(deleteDataSplitted[1]));
          }
          break;
      }
    }
  },
  created: function created() {
    var _this2 = this;

    this.$store.dispatch('chat/resetStateOnLoad');
    if (this.chatIsPast) {
      __WEBPACK_IMPORTED_MODULE_9__repositories_ChatRepository__["a" /* default */].getPastChat(this.$route.params.appointmentId).then(function (response) {
        _this2.chats = [response.data.data.chatInfo];
        _this2.$store.commit('chat/setChatUserDetails', response.data.data.chatInfo);
        _this2.$store.commit('chat/setChatMessages', response.data.data.chatMessages);
      });
    } else {
      __WEBPACK_IMPORTED_MODULE_9__repositories_ChatRepository__["a" /* default */].getAllUserChats().then(function (response) {
        _this2.chats = response.data.data;
        if (_this2.chatsOpened && !_this2.$uiHelpers.isPortrait) _this2.selectChat(_this2.chats[0]);
      });
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    var checkRef = setInterval(function () {
      if (_this3.$refs.messageList) {
        _this3.$store.commit('chat/setRefs', { msgList: _this3.$refs.messageList, msgInput: _this3.$refs.messageInput });
        clearInterval(checkRef);
      }
    }, 100);
  },

  methods: {
    selectChat: function selectChat(selectedChat) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this4.chatUserDetails && selectedChat.idAppointment === _this4.chatUserDetails.idAppointment)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return');

              case 2:
                _this4.$store.commit('chat/resetMsg');
                _this4.$store.commit('chat/setChatUserDetails', selectedChat);
                _context.next = 6;
                return __WEBPACK_IMPORTED_MODULE_9__repositories_ChatRepository__["a" /* default */].getChat(selectedChat.idAppointment).then(function (response) {
                  _this4.$store.commit('chat/setChatMessages', response.data.data);
                  _this4.$store.commit('chat/incrementUnreadMessages', _this4.chatUserDetails.numMessagesPendingRead);
                  _this4.chatUserDetails.numMessagesPendingRead = 0;
                  _this4.$store.dispatch('notifications/get');
                  _this4.$nextTick(function () {
                    _this4.$uiHelpers.centerScreen(_this4.$refs.messageInput);
                    _this4.scrollToLastRead();
                  });
                });

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this4);
      }))();
    },
    getPastChats: function getPastChats() {
      if (this.$store.getters['session/userIsPatient']) {
        this.$router.push({ name: 'pastAppointments', params: { filters: { appointmentType: __WEBPACK_IMPORTED_MODULE_2__constants_consultationTypes__["d" /* CHAT */] } } });
      } else {
        this.$helpers.goToProfessionalWebApp('pastChats');
      }
    },
    setUserType: function setUserType(role) {
      this.userType = role;
      this.selectChat(this.chatList[0]);
    },
    goToProfPage: function goToProfPage() {
      if (!this.chatUserDetails.searchDisabled && this.chatUserDetails.customPageUrl) {
        window.open(this.$helpers.getCustomPageUrl(this.chatUserDetails.customPageUrl));
      }
    },
    finishChatMessage: function finishChatMessage() {
      this.$store.commit('chat/toggleShowDialog', 'finish');
      this.showFinishModal = true;
    },
    emitEPrescription: function emitEPrescription() {
      __WEBPACK_IMPORTED_MODULE_10__repositories_ChipcardRepository__["a" /* default */].createChipcardSession(this.chatUserDetails.patientId, this.chatUserDetails.idAppointment).then(function (response) {
        window.open(response.data.data);
      });
    },
    consolidateChat: function consolidateChat(consolidateRequest) {
      consolidateRequest.AppointmentId = this.chatUserDetails.idAppointment;
      consolidateRequest.WithReport = false;
      __WEBPACK_IMPORTED_MODULE_9__repositories_ChatRepository__["a" /* default */].finishChat(consolidateRequest);
      this.showFinishModal = false;
      this.$store.dispatch('showSuccessAlert', this.$t('chats.finish-chat-message-success'));
    },
    scrollToLastRead: function scrollToLastRead() {
      var messageList = this.$refs.messageList;
      var unreadRef = this.$refs.messagesPendingRead;

      if (messageList && unreadRef && unreadRef.length > 0) {
        var containerTop = messageList.getBoundingClientRect().top;
        var elementTop = unreadRef[0].getBoundingClientRect().top;
        messageList.scrollTop = elementTop - containerTop;
      } else {
        this.$uiHelpers.scrollBottom(messageList);
      }
    },
    showScrollBottomButtonHandler: function showScrollBottomButtonHandler() {
      var messageList = this.$refs.messageList;
      this.showScrollBottomButton = messageList && messageList.scrollTop + messageList.clientHeight < messageList.scrollHeight - 5;
    }
  },
  computed: {
    chatIsPast: function chatIsPast() {
      return this.$route.path.includes('/showChat/');
    },
    chatList: function chatList() {
      if (this.$store.getters['session/userIsProfessional'] && !this.userTypeChatProf) {
        return this.chats.filter(function (x) {
          return !x.isProfessional;
        });
      } else if (this.$store.getters['session/userIsProfessional']) {
        return this.chats.filter(function (x) {
          return x.isProfessional;
        });
      } else {
        return this.chats;
      }
    },
    chatsOpened: function chatsOpened() {
      return this.chatList.length !== 0;
    },
    firstUnreadMessageIndex: function firstUnreadMessageIndex() {
      return this.chatMessages.findIndex(function (msg) {
        return msg.received && !msg.read;
      });
    },
    userTypeChatProf: function userTypeChatProf() {
      return this.userType === __WEBPACK_IMPORTED_MODULE_12__constants_roles__["h" /* PROFESSIONAL_ROLE */];
    },
    defaultImg: function defaultImg() {
      return this.userTypeChatProf ? '/static-appopensalud/img/icons/morillas-svg-icons/primary/doctor.svg' : '/static-appopensalud/img/icons/morillas-svg-icons/primary/user.svg';
    },
    chatUserDetails: function chatUserDetails() {
      return this.$store.state.chat.selectedChat.user;
    },
    chatMessages: function chatMessages() {
      return this.$store.state.chat.selectedChat.messages;
    }
  }
});

/***/ }),

/***/ 3364:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_utils_AudioPlayer_vue__ = __webpack_require__(3958);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_date_helpers__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__repositories_ChatRepository__ = __webpack_require__(1280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_base_BaseDialog__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bootstrap_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_base_buttons_BaseButton_vue__ = __webpack_require__(124);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    AudioPlayer: __WEBPACK_IMPORTED_MODULE_0__components_utils_AudioPlayer_vue__["a" /* default */],
    ChatRepository: __WEBPACK_IMPORTED_MODULE_2__repositories_ChatRepository__["a" /* default */],
    BaseDialog: __WEBPACK_IMPORTED_MODULE_3__components_base_BaseDialog__["default"],
    BIcon: __WEBPACK_IMPORTED_MODULE_4_bootstrap_vue__["C" /* BIcon */],
    BaseButton: __WEBPACK_IMPORTED_MODULE_5__components_base_buttons_BaseButton_vue__["default"]
  },
  props: {
    msg: {
      type: Object,
      required: true
    },
    userPhoto: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      appointmentDateFormat: __WEBPACK_IMPORTED_MODULE_1__helpers_date_helpers__["a" /* appointmentDateFormat */],
      showFullImage: null
    };
  },

  methods: {
    showImageFullSize: function showImageFullSize() {
      var src = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      this.showFullImage = src;
      if (src) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }
    },
    toggleShowMsgOptions: function toggleShowMsgOptions(msgId) {
      this.$store.commit('chat/toggleShowMsgOptions', msgId === this.$store.state.chat.showMsgOptions ? null : msgId);
      if (this.$store.state.chat.showMsgOptions) {
        this.scrollToSeeEditMenu();
      }
    },
    scrollToSeeEditMenu: function scrollToSeeEditMenu() {
      var _this = this;

      this.$nextTick(function () {
        var listPos = _this.$store.state.chat.refs.messageList.getBoundingClientRect();
        var menuPos = _this.$refs.messageMenu.getBoundingClientRect();
        if (menuPos.top <= listPos.top || menuPos.bottom >= listPos.bottom) {
          _this.$store.state.chat.refs.messageList.scrollTo({
            top: _this.$store.state.chat.refs.messageList.scrollTop + _this.$refs.messageMenu.offsetHeight + 2,
            behavior: 'smooth'
          });
        }
      });
    },
    editMessage: function editMessage(msgId) {
      this.$store.commit('chat/setEditingMessage', this.$store.state.chat.selectedChat.messages.find(function (msg) {
        return !msg.received && msg.chatMessageId === msgId;
      }));
      this.$store.commit('chat/setNewMessage', this.$store.state.chat.editingMessage.text || '');
    }
  },
  computed: {
    showDeleteDialog: {
      get: function get() {
        return this.$store.state.chat.showDialog.delete && this.$store.state.chat.showMsgOptions === this.msg.chatMessageId;
      },
      set: function set(value) {}
    }
  }
});

/***/ }),

/***/ 3365:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            isPlaying: false,
            currentTime: 0,
            progress: 0
        };
    },

    props: {
        secondaryStyle: {
            type: Boolean,
            default: false
        },
        src: {
            type: String
        }
    },
    watch: {
        'progress': function progress(value) {
            if (value === 100) {
                this.progress = 0;
                this.$refs.audio.currentTime = 0;
                this.togglePlay();
            }
        }
    },
    methods: {
        togglePlay: function togglePlay() {
            var audio = this.$refs.audio;
            this.isPlaying ? audio.pause() : audio.play();
            this.isPlaying = !this.isPlaying;
        },
        updateProgress: function updateProgress() {
            var audio = this.$refs.audio;
            this.currentTime = audio.currentTime;
            this.progress = audio.currentTime / audio.duration * 100;
        },
        seekAudio: function seekAudio() {
            var audio = this.$refs.audio;
            audio.currentTime = this.progress / 100 * audio.duration;
        },
        setDuration: function setDuration() {
            var audio = this.$refs.audio;
            this.currentTime = audio.currentTime;
        }
    },
    filters: {
        formatTime: function formatTime(time) {
            var minutes = Math.floor(time / 60);
            var seconds = Math.floor(time % 60).toString().padStart(2, '0');
            return minutes + ':' + seconds;
        }
    }
});

/***/ }),

/***/ 3366:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_base_BaseDialog_vue__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_consultationTypes__ = __webpack_require__(1255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__repositories_AppointmentsRepository__ = __webpack_require__(2597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_date_helpers__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_currencies__ = __webpack_require__(2548);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        BaseDialog: __WEBPACK_IMPORTED_MODULE_0__components_base_BaseDialog_vue__["default"]
    },
    props: {
        showDialog: {
            type: Boolean,
            default: false,
            required: true
        },
        appointmentId: {
            type: Number,
            required: true
        }
    },
    data: function data() {
        return {
            cancelReason: null,
            appointmentType: '',
            appointmentDetails: {},
            userInfo: {}
        };
    },

    methods: {
        cancelConsultation: function cancelConsultation() {
            var _this = this;

            if (!this.cancelReason) {
                this.$store.dispatch('showDangerAlert', this.$t('appointmentCancel.noCancelReason'));
            } else {
                // AppointmentsRepository.cancelAppointment(this.appointmentId, this.appointmentDetails.patientId, this.cancelReason).then((response) => {
                this.$ouicareApi.get('Agendas/CancelPersonalAppointmentProfessional', { appointmentID: this.appointmentId, idPaciente: this.appointmentDetails.patientId, Motivo: this.cancelReason }).then(function (response) {
                    if (response.data.status === 200) {
                        _this.$store.dispatch('showSuccessAlert', _this.$t('appointmentCancel.cancel-success'));
                        _this.cancelReason = null;
                        _this.$emit('toggleCancelAppointment');
                    } else {
                        _this.$store.dispatch('showDangerAlert', _this.$t('appointmentCancel.cancel-error'));
                    }
                });
            }
        }
    },
    computed: {
        formattedAppointmentDate: function formattedAppointmentDate() {
            return Object(__WEBPACK_IMPORTED_MODULE_3__helpers_date_helpers__["a" /* appointmentDateFormat */])(this.appointmentDetails.fromDateTime);
        },
        currency: function currency() {
            return Object(__WEBPACK_IMPORTED_MODULE_4__constants_currencies__["a" /* getCurrencyByDomain */])();
        }
    },
    watch: {
        'showDialog': function showDialog(value) {
            var _this2 = this;

            if (value) {
                __WEBPACK_IMPORTED_MODULE_2__repositories_AppointmentsRepository__["a" /* default */].getAppointmentDetails(this.appointmentId).then(function (response) {
                    _this2.appointmentDetails = response.data.data;
                    _this2.appointmentType = Object(__WEBPACK_IMPORTED_MODULE_1__constants_consultationTypes__["o" /* getConsultationTitleById */])(response.data.data.type).toLowerCase();
                });
            }
        }
    }
});

/***/ }),

/***/ 3367:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_base_BaseDialog__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__repositories_SearchRepository__ = __webpack_require__(2719);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__repositories_ProfessionalRepository__ = __webpack_require__(2935);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_base_forms_AttachFile__ = __webpack_require__(3971);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_base_forms_BaseTextarea_vue__ = __webpack_require__(516);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        BaseDialog: __WEBPACK_IMPORTED_MODULE_0__components_base_BaseDialog__["default"],
        BaseTextarea: __WEBPACK_IMPORTED_MODULE_4__components_base_forms_BaseTextarea_vue__["default"],
        AttachFile: __WEBPACK_IMPORTED_MODULE_3__components_base_forms_AttachFile__["a" /* default */]
    },
    props: {
        showDialog: {
            type: Boolean,
            default: false
        },
        userTypeChatProf: {
            type: Boolean,
            default: false,
            required: true
        }
    },
    data: function data() {
        return {
            showAdministrativeDialog: false,
            interconsultationPatient: {
                loading: false,
                options: [],
                value: null
            },
            createChatUser: {
                loading: false,
                options: [],
                value: null
            },
            newMessage: null
        };
    },

    methods: {
        searchPatientByName: function searchPatientByName(name) {
            var _this = this;

            if (name && name.length >= 3) {
                __WEBPACK_IMPORTED_MODULE_2__repositories_ProfessionalRepository__["a" /* default */].getProfPatients(name).then(function (response) {
                    if (_this.userTypeChatProf) {
                        _this.interconsultationPatient.options = response.data;
                    } else {
                        _this.createChatUser.options = response.data;
                    }
                });
            }
        },
        searchProfByName: function searchProfByName(name) {
            var _this2 = this;

            if (name && name.length >= 3) {
                __WEBPACK_IMPORTED_MODULE_1__repositories_SearchRepository__["a" /* default */].getProfsByName(name).then(function (response) {
                    _this2.createChatUser.options = response.data.data;
                });
            }
        },
        getUserPhoto: function getUserPhoto(options, id) {
            var user = options.find(function (item) {
                return item.id === id;
            });
            return user.photo || this.defaultImg;
        }
    },
    computed: {
        defaultImg: function defaultImg() {
            return this.userTypeChatProf ? '/static-appopensalud/img/icons/morillas-svg-icons/primary/doctor.svg' : '/static-appopensalud/img/icons/morillas-svg-icons/primary/user.svg';
        }
    }
});

/***/ }),

/***/ 3368:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__repositories_FilesRepository__ = __webpack_require__(2656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_base_buttons_BaseButton_vue__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue__ = __webpack_require__(18);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    components: { BaseButton: __WEBPACK_IMPORTED_MODULE_1__components_base_buttons_BaseButton_vue__["default"], BIcon: __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue__["C" /* BIcon */] },
    data: function data() {
        return {
            fileTags: [],
            fileTag: null,
            files: []
        };
    },
    created: function created() {
        var _this = this;

        __WEBPACK_IMPORTED_MODULE_0__repositories_FilesRepository__["a" /* default */].getFilesTags().then(function (response) {
            _this.fileTags = response.data.map(function (tag) {
                return { id: tag.id, name: _this.$i18nHelpers.normalize(tag.name) };
            });
        });
    },

    methods: {
        uploadFile: function uploadFile(event) {
            this.files.push(event.target.files[0]);
        },
        getFileIcon: function getFileIcon(file) {
            var fileType = file.type.split('/')[0];
            if (fileType === 'image') return '🖼️';
            if (fileType === 'application') return '📄';
            return '📁';
        },
        removeFile: function removeFile(index) {
            this.files.splice(index, 1);
        }
    },
    computed: {}
});

/***/ }),

/***/ 3369:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_base_forms_BaseTextarea_vue__ = __webpack_require__(516);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        BIcon: __WEBPACK_IMPORTED_MODULE_3_bootstrap_vue__["C" /* BIcon */],
        BaseTextarea: __WEBPACK_IMPORTED_MODULE_4__components_base_forms_BaseTextarea_vue__["default"]
    },
    data: function data() {
        return {
            recordingAudio: false,
            cancelAudio: false,

            mediaRecorder: null,
            audioChunks: [],
            startTime: null,
            elapsedTime: 0,
            intervalId: null
        };
    },

    methods: {
        uploadFile: function uploadFile(file) {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var toBase64, fileData;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                toBase64 = function toBase64(file) {
                                    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                                        var reader = new FileReader();
                                        reader.readAsDataURL(file);
                                        reader.onload = function () {
                                            var encoded = reader.result.toString().replace(/^data:(.*,)?/, '');
                                            if (encoded.length % 4 > 0) {
                                                encoded += '='.repeat(4 - encoded.length % 4);
                                            }
                                            resolve(encoded);
                                        };
                                        reader.onerror = function (error) {
                                            return reject(error);
                                        };
                                    });
                                };

                                if (!file) {
                                    _context.next = 11;
                                    break;
                                }

                                _context.t0 = file.name;
                                _context.t1 = file.type;
                                _context.next = 6;
                                return toBase64(file);

                            case 6:
                                _context.t2 = _context.sent;
                                fileData = {
                                    name: _context.t0,
                                    contentType: _context.t1,
                                    Base64: _context.t2
                                };

                                _this.$store.dispatch('chat/sendMessage', fileData);
                                _context.next = 12;
                                break;

                            case 11:
                                _this.$store.dispatch('showDangerAlert', _this.$t('chats.cant-upload-file'));

                            case 12:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        startRecording: function startRecording() {
            var _this2 = this;

            this.$store.commit('chat/toggleShowMsgOptions');

            navigator.mediaDevices.getUserMedia({ audio: true }).then(function (stream) {
                _this2.recordingAudio = true;
                _this2.audioChunks = [];
                _this2.startTimer();
                _this2.mediaRecorder = new MediaRecorder(stream);
                _this2.mediaRecorder.start();

                _this2.mediaRecorder.ondataavailable = function (event) {
                    _this2.audioChunks.push(event.data);
                };
                _this2.mediaRecorder.onstop = _this2.onStopRecording;
            });
        },
        onStopRecording: function onStopRecording() {
            if (this.cancelAudio) {
                this.audioChunks = [];
                this.cancelAudio = false;
                return;
            }
            var audioBlob = new Blob(this.audioChunks, { type: 'audio/mpeg' });
            var audioFile = new File([audioBlob], 'recording.mpeg', { type: 'audio/mpeg' });
            this.uploadFile(audioFile);
        },
        sendAudio: function sendAudio() {
            if (!this.recordingAudio) return;
            this.recordingAudio = false;
            this.mediaRecorder.stop();
            this.stopTimer();
        },
        cancelRecording: function cancelRecording() {
            if (!this.recordingAudio) return;
            this.recordingAudio = false;
            this.cancelAudio = true;
            this.mediaRecorder.stop();
            this.stopTimer();
        },
        startTimer: function startTimer() {
            var _this3 = this;

            this.startTime = Date.now();
            this.intervalId = setInterval(function () {
                _this3.elapsedTime = Math.floor((Date.now() - _this3.startTime) / 1000);
            }, 1000);
        },
        stopTimer: function stopTimer() {
            clearInterval(this.intervalId);
            this.elapsedTime = 0;
        }
    },
    computed: {
        formattedTime: function formattedTime() {
            var minutes = Math.floor(this.elapsedTime / 60);
            var seconds = this.elapsedTime % 60;
            return String(minutes).padStart(2, '0') + ':' + String(seconds).padStart(2, '0');
        }
    }
});

/***/ }),

/***/ 3953:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3954);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("1ea55daa", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-73c31155\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Chat.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-73c31155\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Chat.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 3954:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale[data-v-73c31155]{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active[data-v-73c31155],.slide-down-leave-active[data-v-73c31155]{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter[data-v-73c31155],.slide-down-leave-to[data-v-73c31155]{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active[data-v-73c31155],.slide-fade-left-leave-active[data-v-73c31155]{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter[data-v-73c31155],.slide-fade-left-leave-to[data-v-73c31155]{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active[data-v-73c31155]{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter[data-v-73c31155],.fade-leave-to[data-v-73c31155]{opacity:0\n}\n.chat-container[data-v-73c31155]{display:-webkit-box;display:-ms-flexbox;display:flex;height:90vh\n}\n@media (orientation: portrait){\n.chat-container[data-v-73c31155]{height:80vh\n}\n}\n.chat-list[data-v-73c31155]{float:left;min-width:280px;width:33%;color:#8A8A8A;margin-right:0.5rem\n}\n@media (orientation: portrait){\n.chat-list[data-v-73c31155]{width:100%;margin-right:0\n}\n}\n.pat-profs-select[data-v-73c31155]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;padding:.8rem\n}\n.chat-card[data-v-73c31155]{background:#eee;position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;border-radius:23px !important;-webkit-box-shadow:14px 14px 25px rgba(13,39,80,0.160784);box-shadow:14px 14px 25px rgba(13,39,80,0.160784);border:0px !important;-webkit-box-sizing:border-box;box-sizing:border-box;height:100%;overflow-y:auto;overflow-x:hidden\n}\n.chat-list ul[data-v-73c31155]{border-radius:23px !important\n}\nul[data-v-73c31155]{margin-top:0;padding-left:0;margin-bottom:1rem\n}\n.chat-list-item[data-v-73c31155]{position:relative;font-size:0.9rem;padding:2rem 3rem;cursor:pointer\n}\n.chat-list-item[data-v-73c31155]:not(.selected):hover{background-color:#3238C4;color:#eee\n}\n.chat-list-item:not(.selected):hover .unread-messages[data-v-73c31155]{background:#eee;color:#3238C4\n}\n.chat-list-item:not(.selected):hover .chat-list-icon[data-v-73c31155]{-webkit-filter:invert(38%) brightness(200%) saturate(100%);filter:invert(38%) brightness(200%) saturate(100%)\n}\n.chat-list-item.selected[data-v-73c31155]{border-left:5px solid #3238C4;background-color:#fff\n}\n.chat-list-photo[data-v-73c31155]{width:2.5rem;height:2.5rem;float:left;border-radius:50%;margin-right:1rem\n}\n.chat-list-photo.chat-list-icon[data-v-73c31155]{border-radius:0\n}\n.chat-list-name[data-v-73c31155]{text-overflow:ellipsis;overflow:hidden;display:inline-block;white-space:nowrap\n}\n.photo-align[data-v-73c31155]{padding-bottom:0.4rem\n}\n.contact-status[data-v-73c31155]{position:absolute;margin:-0.1rem 0 0 -0.1rem;width:0.6rem;height:0.6rem;border-radius:50%;border:1px solid #8A8A8A;background:#979797\n}\n.contact-status.connected[data-v-73c31155]{background:#6AEF89\n}\n.unread-messages[data-v-73c31155]{background:#3238C4;color:#eee;border-radius:20px;position:absolute;right:0.5rem;height:1.2rem;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:0.5rem\n}\n.icon[data-v-73c31155]{height:1.3rem;width:2rem\n}\n.chat-box[data-v-73c31155]{width:67%;overflow:hidden;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column\n}\n@media (orientation: portrait){\n.chat-box[data-v-73c31155]{width:100%\n}\n}\n.chat-header[data-v-73c31155]{width:100%;background-color:#fff;overflow:hidden;display:-webkit-box;display:-ms-flexbox;display:flex\n}\n.chat-header .back-arrow[data-v-73c31155]{float:left;margin:2rem 0 1rem 1rem;vertical-align:middle\n}\n.chat-header .photo[data-v-73c31155]{width:2.8rem;height:2.8rem;float:left;border-radius:50%;margin:1rem 1rem 0.75rem;vertical-align:middle\n}\n.chat-header p[data-v-73c31155]{text-overflow:ellipsis;overflow:hidden;white-space:nowrap;float:left;margin:0\n}\n.chat-header .chat-id[data-v-73c31155]{font-size:0.8rem;color:#979797;width:auto\n}\n@media only screen and (max-width: 575px){\n.chat-header .chat-id[data-v-73c31155]{font-size:0.7rem\n}\n}\n.user-info[data-v-73c31155]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;margin-top:0.6rem;width:60%\n}\n@media only screen and (max-width: 575px){\n.user-info[data-v-73c31155]{margin-top:0.75rem\n}\n}\n.chat-list-info[data-v-73c31155]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column\n}\n.cancel-consultation[data-v-73c31155]{-webkit-box-align:right;-ms-flex-align:right;align-items:right;position:absolute;right:0;margin:1rem 1rem 0.75rem\n}\n.cancel-consultation button[data-v-73c31155]{padding:.3rem .8rem !important\n}\n.cancel-consultation span[data-v-73c31155]{font-size:0.8rem;padding-left:0.5rem\n}\n@media only screen and (max-width: 575px){\n.cancel-consultation span[data-v-73c31155]{display:none\n}\n}\n.finish-consultation-options[data-v-73c31155]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;margin-top:-1rem;cursor:pointer;z-index:3\n}\n.finish-consultation-options p[data-v-73c31155]{margin:0.4rem\n}\n.finish-consultation-options>.e-prescription[data-v-73c31155],.finish-consultation-options>.finish-consultation[data-v-73c31155]{-webkit-box-flex:1;-ms-flex:1;flex:1;text-align:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center\n}\n.finish-consultation-options>.e-prescription[data-v-73c31155]:only-child,.finish-consultation-options>.finish-consultation[data-v-73c31155]:only-child{-webkit-box-flex:0;-ms-flex:none;flex:none;width:100%\n}\n.e-prescription[data-v-73c31155]{background:#3238C4;color:#fff\n}\n.finish-consultation[data-v-73c31155]{background:#FF7061;color:#fff\n}\n.chat-name[data-v-73c31155]{font-size:1.2rem\n}\n@media only screen and (max-width: 575px){\n.chat-name[data-v-73c31155]{font-size:1rem\n}\n}\n.chat-content[data-v-73c31155]{padding:10px;overflow-y:auto;-webkit-box-flex:1;-ms-flex:1;flex:1\n}\n.chat-content[data-v-73c31155]::-webkit-scrollbar{width:4px\n}\n.messages-pending-read[data-v-73c31155]{clear:both;text-align:center;font-weight:bold\n}\n.scroll-end-btn[data-v-73c31155]{background:#fff;color:#3238C4;opacity:70%;border-radius:50%;width:2rem;height:2rem;border:none;cursor:pointer;padding:0.75rem;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;position:absolute;overflow:hidden;right:1em;bottom:8em\n}\n", ""]);

// exports


/***/ }),

/***/ 3955:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChatMessage_vue__ = __webpack_require__(3364);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c4bfcbc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChatMessage_vue__ = __webpack_require__(3962);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(3956)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3c4bfcbc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChatMessage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c4bfcbc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChatMessage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/views/chat-interconsultations/ChatMessage.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3c4bfcbc", Component.options)
  } else {
    hotAPI.reload("data-v-3c4bfcbc", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 3956:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3957);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("92b70fd8", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3c4bfcbc\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ChatMessage.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3c4bfcbc\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ChatMessage.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 3957:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale[data-v-3c4bfcbc]{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active[data-v-3c4bfcbc],.slide-down-leave-active[data-v-3c4bfcbc]{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter[data-v-3c4bfcbc],.slide-down-leave-to[data-v-3c4bfcbc]{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active[data-v-3c4bfcbc],.slide-fade-left-leave-active[data-v-3c4bfcbc]{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter[data-v-3c4bfcbc],.slide-fade-left-leave-to[data-v-3c4bfcbc]{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active[data-v-3c4bfcbc]{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter[data-v-3c4bfcbc],.fade-leave-to[data-v-3c4bfcbc]{opacity:0\n}\n.message-block[data-v-3c4bfcbc]{display:block;clear:both;font-size:0.9rem;padding-bottom:0.5rem\n}\n.sent[data-v-3c4bfcbc]{float:right\n}\n.sent p[data-v-3c4bfcbc]{float:right;background-color:#3238C4;color:#eee\n}\n.sent img[data-v-3c4bfcbc]{background-color:#3238C4;color:#eee;float:right;cursor:pointer\n}\n.sent .message-photo[data-v-3c4bfcbc]{float:right;margin-left:10px\n}\n.sent .message-date[data-v-3c4bfcbc]{float:right\n}\n.received[data-v-3c4bfcbc]{float:left\n}\n.received p[data-v-3c4bfcbc]{float:left;background-color:#fff;color:#3238C4\n}\n.received img[data-v-3c4bfcbc]{background-color:#fff;color:#3238C4;float:left;cursor:pointer\n}\n.received .message-photo[data-v-3c4bfcbc]{float:left;margin-right:10px\n}\n.received .message-date[data-v-3c4bfcbc]{float:left\n}\n.chat-message[data-v-3c4bfcbc]{margin:.5rem 0;max-width:80%;padding:10px;border-radius:20px;white-space:pre-wrap\n}\n.chat-message.image-message[data-v-3c4bfcbc]{height:30rem;width:30rem;-o-object-fit:cover;object-fit:cover;cursor:pointer\n}\n.audio-message[data-v-3c4bfcbc]{margin:.5rem 0;max-width:80%\n}\n.message-photo[data-v-3c4bfcbc]{width:30px;height:30px;border-radius:50%;margin-top:0.8rem\n}\n.message-edit-delete[data-v-3c4bfcbc]{position:relative;background-color:#fff;color:#3238C4;border-radius:20px;z-index:3;padding:0.5rem 1rem;width:-webkit-min-content;width:-moz-min-content;width:min-content;display:-webkit-box;display:-ms-flexbox;display:flex\n}\n.message-edit-delete .message-edit-element[data-v-3c4bfcbc]{display:-webkit-box;display:-ms-flexbox;display:flex;cursor:pointer\n}\n.message-edit-delete .delete[data-v-3c4bfcbc]{color:#FF7061\n}\n.message-date[data-v-3c4bfcbc]{display:block\n}\n.imgFullSize[data-v-3c4bfcbc]{position:fixed;top:0;left:0;width:100vw;height:100vh;background-color:rgba(0,0,0,0.8);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;z-index:3\n}\n.imgFullSize img[data-v-3c4bfcbc]{max-width:90%;max-height:90%;border-radius:8px\n}\n", ""]);

// exports


/***/ }),

/***/ 3958:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AudioPlayer_vue__ = __webpack_require__(3365);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e04dad0e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AudioPlayer_vue__ = __webpack_require__(3961);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(3959)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e04dad0e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AudioPlayer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e04dad0e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AudioPlayer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/utils/AudioPlayer.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-e04dad0e", Component.options)
  } else {
    hotAPI.reload("data-v-e04dad0e", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 3959:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3960);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("463f5fe6", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-e04dad0e\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./AudioPlayer.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-e04dad0e\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./AudioPlayer.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 3960:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale[data-v-e04dad0e]{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active[data-v-e04dad0e],.slide-down-leave-active[data-v-e04dad0e]{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter[data-v-e04dad0e],.slide-down-leave-to[data-v-e04dad0e]{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active[data-v-e04dad0e],.slide-fade-left-leave-active[data-v-e04dad0e]{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter[data-v-e04dad0e],.slide-fade-left-leave-to[data-v-e04dad0e]{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active[data-v-e04dad0e]{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter[data-v-e04dad0e],.fade-leave-to[data-v-e04dad0e]{opacity:0\n}\n.audio-player[data-v-e04dad0e]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:10px;border-radius:23px\n}\n.primary[data-v-e04dad0e]{background-color:#3238C4\n}\n.primary .play-pause-button[data-v-e04dad0e]{background-color:#3238C4;color:#fff\n}\n.primary input[type=\"range\"][data-v-e04dad0e]{color:#fff\n}\n.primary span[data-v-e04dad0e]{color:#fff\n}\n.secondary[data-v-e04dad0e]{background-color:#fff\n}\n.secondary .play-pause-button[data-v-e04dad0e]{background-color:#fff;color:#3238C4\n}\n.secondary input[type=\"range\"][data-v-e04dad0e]{color:#3238C4\n}\n.secondary span[data-v-e04dad0e]{color:#3238C4\n}\n.play-pause-button[data-v-e04dad0e]{border:none;display:-webkit-box;display:-ms-flexbox;display:flex\n}\ninput[type=\"range\"][data-v-e04dad0e]{margin:0 10px;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;height:5px;border-radius:5px;background-color:#eee\n}\nspan[data-v-e04dad0e]{font-size:0.9rem\n}\n.icon[data-v-e04dad0e]{height:1.3rem;width:2rem\n}\n", ""]);

// exports


/***/ }),

/***/ 3961:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "d-flex" }, [
    _c(
      "div",
      { class: ["audio-player", _vm.secondaryStyle ? "secondary" : "primary"] },
      [
        _c(
          "button",
          { staticClass: "play-pause-button", on: { click: _vm.togglePlay } },
          [
            _vm.isPlaying
              ? _c("b-icon-pause-fill", { staticClass: "icon" })
              : _c("b-icon-play-fill", { staticClass: "icon" })
          ],
          1
        ),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.progress,
              expression: "progress"
            }
          ],
          staticClass: "audio-bar",
          attrs: { type: "range", max: "100" },
          domProps: { value: _vm.progress },
          on: {
            input: _vm.seekAudio,
            __r: function($event) {
              _vm.progress = $event.target.value
            }
          }
        }),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm._f("formatTime")(_vm.currentTime)))])
      ]
    ),
    _vm._v(" "),
    _c(
      "audio",
      {
        ref: "audio",
        attrs: { preload: "auto" },
        on: { timeupdate: _vm.updateProgress, loadedmetadata: _vm.setDuration }
      },
      [_c("source", { attrs: { src: _vm.src, type: "audio/mpeg" } })]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e04dad0e", esExports)
  }
}

/***/ }),

/***/ 3962:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: ["message-block", _vm.msg.received ? "received" : "sent"] },
    [
      _vm.msg.received
        ? _c("img", {
            staticClass: "message-photo",
            attrs: { src: _vm.userPhoto, alt: "" }
          })
        : _c("img", {
            staticClass: "message-photo",
            attrs: { src: _vm.$store.state.session.user.photo, alt: "" }
          }),
      _vm._v(" "),
      !_vm.msg.file
        ? _c("p", {
            staticClass: "chat-message",
            domProps: { innerHTML: _vm._s(_vm.msg.text) }
          })
        : _vm.msg.file.contentType.includes("audio")
        ? _c("audio-player", {
            staticClass: "audio-message",
            attrs: {
              secondaryStyle: _vm.msg.received,
              src: _vm.msg.file.fileUrl
            }
          })
        : _vm.msg.file.contentType.includes("image")
        ? _c("img", {
            staticClass: "chat-message image-message",
            attrs: { src: _vm.msg.file.fileUrl, alt: "" },
            on: {
              click: function($event) {
                return _vm.showImageFullSize(_vm.msg.file.fileUrl)
              }
            }
          })
        : _c("p", { staticClass: "chat-message" }, [
            _c(
              "a",
              {
                attrs: {
                  href: _vm.msg.file.fileUrl,
                  download: _vm.msg.file.name
                }
              },
              [
                _c(
                  "base-button",
                  {
                    style: "border-width: 1px; border-color: white",
                    attrs: { white: _vm.msg.received }
                  },
                  [
                    _c(
                      "span",
                      [
                        _c("b-icon-file-earmark-text"),
                        _vm._v("  " + _vm._s(_vm.msg.file.name))
                      ],
                      1
                    )
                  ]
                )
              ],
              1
            )
          ]),
      _vm._v(" "),
      _c("div", [
        _vm.msg.received || _vm.$store.state.chat.selectedChat.user.terminated
          ? _c("span", { staticClass: "message-date" }, [
              _vm._v(_vm._s(_vm.appointmentDateFormat(_vm.msg.date, true))),
              _vm.msg.edited
                ? _c("span", [_vm._v(" | " + _vm._s(_vm.$t("edited")))])
                : _vm._e()
            ])
          : _c("div", [
              _c(
                "span",
                { staticClass: "message-date" },
                [
                  _c("b-icon-three-dots", {
                    staticStyle: { cursor: "pointer" },
                    on: {
                      click: function($event) {
                        return _vm.toggleShowMsgOptions(_vm.msg.chatMessageId)
                      }
                    }
                  }),
                  _vm.msg.edited
                    ? _c("span", [_vm._v(" | " + _vm._s(_vm.$t("edited")))])
                    : _vm._e(),
                  _vm._v(" | "),
                  _vm.msg.read ? _c("b-icon-eye") : _vm._e(),
                  _vm._v(
                    " " +
                      _vm._s(_vm.appointmentDateFormat(_vm.msg.date, true)) +
                      "\n        "
                  ),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.$store.state.chat.showMsgOptions ===
                            _vm.msg.chatMessageId,
                          expression:
                            "$store.state.chat.showMsgOptions === msg.chatMessageId"
                        }
                      ],
                      ref: "messageMenu",
                      staticClass: "message-edit-delete"
                    },
                    [
                      _c("div", { staticClass: "mb-1" }, [
                        !_vm.msg.file
                          ? _c(
                              "span",
                              {
                                staticClass: "message-edit-element mr-3",
                                on: {
                                  click: function($event) {
                                    return _vm.editMessage(
                                      _vm.msg.chatMessageId
                                    )
                                  }
                                }
                              },
                              [
                                _c("b-icon-pencil", {
                                  staticClass: "mt-1 mr-1"
                                }),
                                _vm._v(_vm._s(_vm.$t("edit")))
                              ],
                              1
                            )
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _c(
                          "span",
                          {
                            staticClass: "message-edit-element delete",
                            on: {
                              click: function($event) {
                                return _vm.$store.commit(
                                  "chat/toggleShowDialog",
                                  "delete"
                                )
                              }
                            }
                          },
                          [
                            _c("b-icon-trash", { staticClass: "mt-1 mr-1" }),
                            _vm._v(_vm._s(_vm.$t("chats.delete")))
                          ],
                          1
                        )
                      ])
                    ]
                  )
                ],
                1
              )
            ])
      ]),
      _vm._v(" "),
      _vm.showFullImage
        ? _c(
            "div",
            {
              staticClass: "imgFullSize",
              on: {
                click: function($event) {
                  return _vm.showImageFullSize()
                }
              }
            },
            [_c("img", { attrs: { src: _vm.showFullImage, alt: "" } })]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("base-dialog", {
        attrs: {
          content: _vm.$t("chats.delete-message"),
          okBtnText: _vm.$t("yes"),
          cancelBtnText: _vm.$t("no"),
          okFn: function() {
            _vm.$store.dispatch("chat/deleteMessage", _vm.msg.chatMessageId)
          },
          cancelFn: function() {
            _vm.$store.commit("chat/toggleShowDialog", "delete")
          }
        },
        model: {
          value: _vm.showDeleteDialog,
          callback: function($$v) {
            _vm.showDeleteDialog = $$v
          },
          expression: "showDeleteDialog"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3c4bfcbc", esExports)
  }
}

/***/ }),

/***/ 3963:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(25);


var client = function client() {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$api;
};

/* harmony default export */ __webpack_exports__["a"] = ({
    createChipcardSession: function createChipcardSession(patientId, appointmentId) {
        return client().get('Chipcard/CreateChipcardSession', { params: { idCita: appointmentId, idPatient: patientId } });
    }
});

/***/ }),

/***/ 3964:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CancelAppointmentModal_vue__ = __webpack_require__(3366);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ef8b480_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CancelAppointmentModal_vue__ = __webpack_require__(3967);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(3965)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CancelAppointmentModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ef8b480_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CancelAppointmentModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/webapp/shared/CancelAppointmentModal.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3ef8b480", Component.options)
  } else {
    hotAPI.reload("data-v-3ef8b480", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 3965:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3966);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("fba88fe4", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3ef8b480\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./CancelAppointmentModal.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3ef8b480\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./CancelAppointmentModal.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 3966:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active,.slide-down-leave-active{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter,.slide-down-leave-to{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active,.slide-fade-left-leave-active{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter,.slide-fade-left-leave-to{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter,.fade-leave-to{opacity:0\n}\n.details-photo{width:8rem;height:8rem;border-radius:50%;margin:1rem 1rem 0.75rem;vertical-align:middle\n}\n@media only screen and (max-width: 575px){\n.details-photo{width:5rem;height:5rem\n}\n}\n.details-container{height:10rem;text-align:center\n}\n.appointment-container{padding-left:1.5rem\n}\n@media only screen and (max-width: 575px){\n.appointment-container{padding-top:1.5rem;padding-left:0\n}\n}\n.details-text{margin:0.4rem 0;font-size:0.9rem\n}\n@media only screen and (max-width: 575px){\n.details-text{font-size:0.8rem\n}\n}\n.details-name{margin-top:0.4rem;font-size:1.2rem;margin-bottom:0.1rem\n}\n@media only screen and (max-width: 575px){\n.details-name{font-size:1rem\n}\n}\n.reason-container{padding-top:1.5rem\n}\n.message-text{width:100%;-webkit-box-sizing:border-box;box-sizing:border-box\n}\n", ""]);

// exports


/***/ }),

/***/ 3967:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "base-dialog",
        {
          attrs: {
            keepOpened: "",
            title:
              _vm.$t("appointmentCancel.cancel") + " " + _vm.appointmentType,
            okBtnText:
              _vm.$t("appointmentCancel.wantToCancel") +
              " (" +
              _vm.appointmentType +
              ")",
            okBtnVariant: "danger",
            cancelBtnText: _vm.$t("back"),
            cancelBtnVariant: "secondary",
            okFn: function() {
              _vm.cancelConsultation()
            },
            cancelFn: function() {
              _vm.$emit("toggleCancelAppointment")
            }
          },
          model: {
            value: _vm.showDialog,
            callback: function($$v) {
              _vm.showDialog = $$v
            },
            expression: "showDialog"
          }
        },
        [
          [
            _vm.appointmentDetails.patientData
              ? _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      {
                        attrs: {
                          cols: "12",
                          xs: "12",
                          md: "6",
                          lg: "6",
                          xl: "6"
                        }
                      },
                      [
                        _c("b-row", [
                          _c("h5", [
                            _vm._v(
                              _vm._s(_vm.$t("appointmentCancel.patientData"))
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          { staticClass: "align-items-center" },
                          [
                            _c(
                              "b-col",
                              { attrs: { cols: "5", xs: "5" } },
                              [
                                _c("b-row", [
                                  _c("img", {
                                    staticClass: "details-photo",
                                    attrs: {
                                      src:
                                        _vm.appointmentDetails.patientData
                                          .photo,
                                      alt: ""
                                    }
                                  })
                                ])
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              {
                                staticClass: "details-container",
                                attrs: { cols: "7", xs: "7" }
                              },
                              [
                                _c("b-row", [
                                  _c("p", { staticClass: "details-name" }, [
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.appointmentDetails.patientData
                                            .fullName
                                        )
                                      )
                                    ])
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("b-row", [
                                  _c("p", { staticClass: "details-text" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.appointmentDetails.patientData
                                          .fullAddress
                                      )
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("b-row", [
                                  _c("p", { staticClass: "details-text" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.appointmentDetails.patientData.email
                                      )
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("b-row", [
                                  _c("p", { staticClass: "details-text" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.appointmentDetails.patientData
                                          .phonenumber
                                      )
                                    )
                                  ])
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      {
                        staticClass: "appointment-container",
                        attrs: {
                          cols: "12",
                          xs: "12",
                          md: "6",
                          lg: "6",
                          xl: "6"
                        }
                      },
                      [
                        _c("b-row", [
                          _c("h5", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("appointmentCancel.appointmentSummary")
                              )
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              [
                                _c("b-row", [
                                  _c("p", { staticClass: "details-text" }, [
                                    _c("strong", [
                                      _vm._v(_vm._s(_vm.$t("date") + ":"))
                                    ]),
                                    _vm._v(
                                      " " + _vm._s(_vm.formattedAppointmentDate)
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _vm.appointmentDetails.duration
                                  ? _c("b-row", [
                                      _c("p", { staticClass: "details-text" }, [
                                        _c("strong", [
                                          _vm._v(
                                            _vm._s(_vm.$t("duration") + ":")
                                          )
                                        ]),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.appointmentDetails.duration
                                            )
                                        )
                                      ])
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("b-row", [
                                  _c("p", { staticClass: "details-text" }, [
                                    _c("strong", [
                                      _vm._v(_vm._s(_vm.$t("price") + ":"))
                                    ]),
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.appointmentDetails.price) +
                                        " " +
                                        _vm._s(_vm.currency)
                                    )
                                  ])
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "b-row",
              { staticClass: "reason-container" },
              [
                _c("b-row", [
                  _c("h5", [
                    _vm._v(
                      _vm._s(_vm.$t("appointmentCancel.cancelationReason"))
                    )
                  ])
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              [
                _c("base-textarea", {
                  staticClass: "message-text mt-2",
                  attrs: {
                    rows: 1,
                    "max-rows": 5,
                    placeholder: _vm.$t("appointmentCancel.writeAReason")
                  },
                  model: {
                    value: _vm.cancelReason,
                    callback: function($$v) {
                      _vm.cancelReason = $$v
                    },
                    expression: "cancelReason"
                  }
                })
              ],
              1
            )
          ]
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3ef8b480", esExports)
  }
}

/***/ }),

/***/ 3968:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdministrativeChatModal_vue__ = __webpack_require__(3367);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0016e43a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdministrativeChatModal_vue__ = __webpack_require__(3975);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(3969)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdministrativeChatModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0016e43a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdministrativeChatModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/views/chat-interconsultations/AdministrativeChatModal.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0016e43a", Component.options)
  } else {
    hotAPI.reload("data-v-0016e43a", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 3969:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3970);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("d64f625a", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-0016e43a\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./AdministrativeChatModal.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-0016e43a\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./AdministrativeChatModal.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 3970:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active,.slide-down-leave-active{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter,.slide-down-leave-to{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active,.slide-fade-left-leave-active{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter,.slide-fade-left-leave-to{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter,.fade-leave-to{opacity:0\n}\n.photo-option{border-radius:50%;padding:0;width:30px;height:30px\n}\n", ""]);

// exports


/***/ }),

/***/ 3971:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AttachFile_vue__ = __webpack_require__(3368);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58f5f77f_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AttachFile_vue__ = __webpack_require__(3974);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(3972)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-58f5f77f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AttachFile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58f5f77f_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AttachFile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/base/forms/AttachFile.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-58f5f77f", Component.options)
  } else {
    hotAPI.reload("data-v-58f5f77f", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 3972:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3973);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("cd2dbee2", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-58f5f77f\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./AttachFile.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-58f5f77f\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./AttachFile.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 3973:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale[data-v-58f5f77f]{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active[data-v-58f5f77f],.slide-down-leave-active[data-v-58f5f77f]{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter[data-v-58f5f77f],.slide-down-leave-to[data-v-58f5f77f]{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active[data-v-58f5f77f],.slide-fade-left-leave-active[data-v-58f5f77f]{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter[data-v-58f5f77f],.slide-fade-left-leave-to[data-v-58f5f77f]{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active[data-v-58f5f77f]{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter[data-v-58f5f77f],.fade-leave-to[data-v-58f5f77f]{opacity:0\n}\n.attach-button[data-v-58f5f77f]{width:100%\n}\n", ""]);

// exports


/***/ }),

/***/ 3974:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", [_c("span", [_vm._v(_vm._s(_vm.$t("chats.attach-file")))])]),
      _vm._v(" "),
      _c("base-select", {
        staticClass: "mt-1",
        attrs: {
          clearable: "",
          avoidDefaultSort: "",
          loading: false,
          options: _vm.fileTags,
          valueProp: "id",
          label: "name",
          placeholder: _vm.$t("chats.select-file-type")
        },
        model: {
          value: _vm.fileTag,
          callback: function($$v) {
            _vm.fileTag = $$v
          },
          expression: "fileTag"
        }
      }),
      _vm._v(" "),
      _vm.fileTag
        ? _c(
            "div",
            { staticClass: "mt-2" },
            [
              _c(
                "base-button",
                {
                  staticClass: "attach-button",
                  on: {
                    click: function($event) {
                      return _vm.$refs.fileInput.click()
                    }
                  }
                },
                [
                  _c("b-icon-paperclip", { staticClass: "mr-2" }),
                  _c("span", [_vm._v(_vm._s(_vm.$t("chats.select-file")))]),
                  _c("input", {
                    ref: "fileInput",
                    staticClass: "d-none",
                    attrs: { type: "file" },
                    on: {
                      change: function($event) {
                        return _vm.uploadFile($event)
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.files.length
        ? _c(
            "div",
            { staticClass: "mt-2" },
            _vm._l(_vm.files, function(file, index) {
              return _c(
                "div",
                { key: index, staticClass: "file-item" },
                [
                  _c("span", { staticClass: "file-icon" }, [
                    _vm._v(_vm._s(_vm.getFileIcon(file)))
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "file-name" }, [
                    _vm._v(_vm._s(file.name))
                  ]),
                  _vm._v(" "),
                  _c(
                    "base-button",
                    {
                      attrs: { red: "" },
                      on: {
                        click: function($event) {
                          return _vm.removeFile(index)
                        }
                      }
                    },
                    [_c("b-icon-trash")],
                    1
                  )
                ],
                1
              )
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showLink ? _c("div") : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-58f5f77f", esExports)
  }
}

/***/ }),

/***/ 3975:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "base-dialog",
        {
          attrs: {
            title: _vm.$t("chats.administrative-chat"),
            okBtnText: _vm.$t("create"),
            okBtnVariant: "success",
            cancelBtnText: _vm.$t("back"),
            cancelBtnVariant: "secondary",
            okFn: _vm.createChatUser.value
              ? function() {
                  _vm.createChat()
                }
              : null,
            cancelFn: function() {
              _vm.$emit("toggleShowAdministrativeChat")
            }
          },
          model: {
            value: _vm.showDialog,
            callback: function($$v) {
              _vm.showDialog = $$v
            },
            expression: "showDialog"
          }
        },
        [
          [
            _c("div", [
              _vm.userTypeChatProf
                ? _c("span", [_vm._v(_vm._s(_vm.$t("professional")))])
                : _c("span", [_vm._v(_vm._s(_vm.$t("patient")))])
            ]),
            _vm._v(" "),
            _c("base-select", {
              attrs: {
                searchable: "",
                clearable: "",
                avoidDefaultSort: "",
                loading: _vm.createChatUser.loading,
                options: _vm.createChatUser.options,
                valueProp: "id",
                label: "name",
                placeholder: _vm.userTypeChatProf
                  ? _vm.$t("chats.select-prof")
                  : _vm.$t("chats.select-patient")
              },
              on: {
                search: function($event) {
                  _vm.userTypeChatProf
                    ? _vm.searchProfByName($event)
                    : _vm.searchPatientByName($event)
                }
              },
              scopedSlots: _vm._u([
                {
                  key: "option",
                  fn: function(data) {
                    return [
                      _c("div", [
                        _c("img", {
                          staticClass: "photo-option",
                          attrs: {
                            src: _vm.getUserPhoto(
                              _vm.createChatUser.options,
                              data.option.value
                            ),
                            alt: ""
                          }
                        }),
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(data.option.label))])
                      ])
                    ]
                  }
                }
              ]),
              model: {
                value: _vm.createChatUser.value,
                callback: function($$v) {
                  _vm.$set(_vm.createChatUser, "value", $$v)
                },
                expression: "createChatUser.value"
              }
            }),
            _vm._v(" "),
            _vm.createChatUser.value
              ? _c("base-textarea", {
                  staticClass: "mt-2",
                  attrs: {
                    rows: 1,
                    "max-rows": 5,
                    placeholder: _vm.$t("chats.new-message")
                  },
                  model: {
                    value: _vm.newMessage,
                    callback: function($$v) {
                      _vm.newMessage = $$v
                    },
                    expression: "newMessage"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.createChatUser.value && !_vm.userTypeChatProf
              ? _c("attach-file")
              : _vm._e(),
            _vm._v(" "),
            _vm.createChatUser.value && _vm.userTypeChatProf
              ? _c("base-select", {
                  attrs: {
                    searchable: "",
                    clearable: "",
                    avoidDefaultSort: "",
                    loading: _vm.interconsultationPatient.loading,
                    options: _vm.interconsultationPatient.options,
                    valueProp: "id",
                    label: "name",
                    placeholder: _vm.$t("chats.select-patient")
                  },
                  on: {
                    search: function($event) {
                      return _vm.searchPatientByName($event)
                    }
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "option",
                        fn: function(data) {
                          return [
                            _c("div", [
                              _c("img", {
                                staticClass: "photo-option",
                                attrs: {
                                  src: _vm.getUserPhoto(
                                    _vm.interconsultationPatient.options,
                                    data.option.value
                                  ),
                                  alt: ""
                                }
                              }),
                              _vm._v(" "),
                              _c("span", [_vm._v(_vm._s(data.option.label))])
                            ])
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    4203853806
                  ),
                  model: {
                    value: _vm.interconsultationPatient.value,
                    callback: function($$v) {
                      _vm.$set(_vm.interconsultationPatient, "value", $$v)
                    },
                    expression: "interconsultationPatient.value"
                  }
                })
              : _vm._e()
          ]
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0016e43a", esExports)
  }
}

/***/ }),

/***/ 3976:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChatMessageInput_vue__ = __webpack_require__(3369);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d25bc78_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChatMessageInput_vue__ = __webpack_require__(3979);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(3977)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7d25bc78"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChatMessageInput_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d25bc78_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChatMessageInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/views/chat-interconsultations/ChatMessageInput.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7d25bc78", Component.options)
  } else {
    hotAPI.reload("data-v-7d25bc78", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 3977:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3978);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("56b22f16", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7d25bc78\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ChatMessageInput.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7d25bc78\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ChatMessageInput.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 3978:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale[data-v-7d25bc78]{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active[data-v-7d25bc78],.slide-down-leave-active[data-v-7d25bc78]{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter[data-v-7d25bc78],.slide-down-leave-to[data-v-7d25bc78]{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active[data-v-7d25bc78],.slide-fade-left-leave-active[data-v-7d25bc78]{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter[data-v-7d25bc78],.slide-fade-left-leave-to[data-v-7d25bc78]{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active[data-v-7d25bc78]{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter[data-v-7d25bc78],.fade-leave-to[data-v-7d25bc78]{opacity:0\n}\n.message-input[data-v-7d25bc78]{width:100%;z-index:2;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding-left:1rem\n}\n.message-input[data-v-7d25bc78] .message-text textarea{background:#fff;-webkit-box-sizing:border-box;box-sizing:border-box;text-align:left\n}\n.message-input[data-v-7d25bc78] .message-text textarea::-webkit-input-placeholder{display:-webkit-box;display:flex\n}\n.message-input[data-v-7d25bc78] .message-text textarea::-moz-placeholder{display:flex\n}\n.message-input[data-v-7d25bc78] .message-text textarea::-ms-input-placeholder{display:-ms-flexbox;display:flex\n}\n.message-input[data-v-7d25bc78] .message-text textarea::placeholder{display:-webkit-box;display:-ms-flexbox;display:flex\n}\n.message-input .message-text[data-v-7d25bc78]::-webkit-scrollbar{display:none\n}\n.message-input .chat-input-buttons[data-v-7d25bc78]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin-bottom:1.5rem\n}\n.message-input .icon-btn[data-v-7d25bc78]{background:#3238C4;color:#eee;border-radius:50%;width:3rem;height:3rem;border:none;cursor:pointer;padding:0.75rem;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center\n}\n.message-input .recorder[data-v-7d25bc78]{margin-bottom:1.5rem;height:61px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center\n}\n.message-input .recorder span[data-v-7d25bc78]{position:absolute;right:0;padding-right:1rem\n}\n.message-input .recorder .recording.icon[data-v-7d25bc78]{color:#FF7061\n}\n.message-input .icon-btn.cancel[data-v-7d25bc78]{background:#FF7061\n}\n.icon[data-v-7d25bc78]{height:1.3rem;width:2rem\n}\n", ""]);

// exports


/***/ }),

/***/ 3979:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.$store.state.chat.editingMessage
        ? _c(
            "b-row",
            { staticClass: "message-input" },
            [
              _c(
                "b-col",
                {
                  attrs: {
                    xs: "6",
                    sm: "6",
                    md: "8",
                    lg: "10",
                    xl: "10",
                    cols: "8"
                  }
                },
                [
                  _c("base-textarea", {
                    staticClass: "message-text",
                    attrs: {
                      rows: 1,
                      "max-rows": 5,
                      placeholder: _vm.$t("chats.new-message")
                    },
                    model: {
                      value: _vm.$store.state.chat.newMessage,
                      callback: function($$v) {
                        _vm.$set(_vm.$store.state.chat, "newMessage", $$v)
                      },
                      expression: "$store.state.chat.newMessage"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass: "chat-input-buttons",
                  attrs: {
                    xs: "3",
                    sm: "3",
                    md: "2",
                    lg: "1",
                    xl: "1",
                    cols: "2"
                  }
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "icon-btn",
                      on: {
                        click: function($event) {
                          return _vm.$store.dispatch("chat/editMessage")
                        }
                      }
                    },
                    [_c("b-icon-check-lg", { staticClass: "icon" })],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass: "chat-input-buttons",
                  attrs: {
                    xs: "3",
                    sm: "3",
                    md: "2",
                    lg: "1",
                    xl: "1",
                    cols: "2"
                  }
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "icon-btn cancel",
                      on: {
                        click: function($event) {
                          return _vm.$store.commit("chat/resetMsg")
                        }
                      }
                    },
                    [_c("b-icon-x-lg", { staticClass: "icon" })],
                    1
                  )
                ]
              )
            ],
            1
          )
        : _vm.recordingAudio
        ? _c(
            "b-row",
            { staticClass: "message-input" },
            [
              _c(
                "b-col",
                {
                  attrs: {
                    xs: "6",
                    sm: "6",
                    md: "8",
                    lg: "10",
                    xl: "10",
                    cols: "8"
                  }
                },
                [
                  _c("div", { staticClass: "recorder" }, [
                    _c(
                      "span",
                      [
                        _c("b-icon-circle-fill", {
                          staticClass: "recording icon",
                          attrs: { animation: "throb" }
                        }),
                        _vm._v(_vm._s(_vm.formattedTime))
                      ],
                      1
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass: "chat-input-buttons",
                  attrs: {
                    xs: "3",
                    sm: "3",
                    md: "2",
                    lg: "1",
                    xl: "1",
                    cols: "2"
                  }
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "icon-btn cancel",
                      on: {
                        click: function($event) {
                          return _vm.cancelRecording()
                        }
                      }
                    },
                    [_c("b-icon-trash-fill", { staticClass: "icon" })],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass: "chat-input-buttons",
                  attrs: {
                    xs: "3",
                    sm: "3",
                    md: "2",
                    lg: "1",
                    xl: "1",
                    cols: "2"
                  }
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "icon-btn",
                      on: {
                        click: function($event) {
                          return _vm.sendAudio()
                        }
                      }
                    },
                    [_c("b-icon-cursor-fill", { staticClass: "icon" })],
                    1
                  )
                ]
              )
            ],
            1
          )
        : _c(
            "b-row",
            { staticClass: "message-input" },
            [
              _c(
                "b-col",
                {
                  attrs: {
                    xs: "6",
                    sm: "6",
                    md: "8",
                    lg: "10",
                    xl: "10",
                    cols: "8"
                  }
                },
                [
                  _c("base-textarea", {
                    staticClass: "message-text",
                    attrs: {
                      rows: 1,
                      "max-rows": 5,
                      placeholder: _vm.$t("chats.new-message")
                    },
                    model: {
                      value: _vm.$store.state.chat.newMessage,
                      callback: function($$v) {
                        _vm.$set(_vm.$store.state.chat, "newMessage", $$v)
                      },
                      expression: "$store.state.chat.newMessage"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass: "chat-input-buttons",
                  attrs: {
                    xs: "3",
                    sm: "3",
                    md: "2",
                    lg: "1",
                    xl: "1",
                    cols: "2"
                  }
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "icon-btn",
                      on: {
                        click: function($event) {
                          return _vm.$refs.fileInput.click()
                        }
                      }
                    },
                    [
                      _c("b-icon-paperclip", { staticClass: "icon" }),
                      _c("input", {
                        ref: "fileInput",
                        staticClass: "d-none",
                        attrs: { type: "file" },
                        on: {
                          change: function($event) {
                            return _vm.uploadFile($event.target.files[0])
                          }
                        }
                      })
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass: "chat-input-buttons",
                  attrs: {
                    xs: "3",
                    sm: "3",
                    md: "2",
                    lg: "1",
                    xl: "1",
                    cols: "2"
                  }
                },
                [
                  _vm.$store.state.chat.newMessage !== ""
                    ? _c(
                        "button",
                        {
                          staticClass: "icon-btn",
                          on: {
                            click: function($event) {
                              return _vm.$store.dispatch("chat/sendMessage")
                            }
                          }
                        },
                        [_c("b-icon-cursor-fill", { staticClass: "icon" })],
                        1
                      )
                    : _c(
                        "button",
                        {
                          staticClass: "icon-btn",
                          on: {
                            click: function($event) {
                              return _vm.startRecording()
                            }
                          }
                        },
                        [_c("b-icon-mic-fill", { staticClass: "icon" })],
                        1
                      )
                ]
              )
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7d25bc78", esExports)
  }
}

/***/ }),

/***/ 3980:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "chat-container" }, [
    (_vm.chatsOpened && !_vm.chatUserDetails && _vm.$uiHelpers.isPortrait) ||
    !_vm.$uiHelpers.isPortrait
      ? _c("div", { staticClass: "chat-list chat-card" }, [
          _vm.$store.getters["session/userIsProfessional"]
            ? _c(
                "div",
                { staticClass: "pat-profs-select" },
                [
                  _c(
                    "base-button",
                    {
                      staticClass: "mr-1 d-flex justify-content-center",
                      staticStyle: { width: "50%" },
                      attrs: { white: _vm.userTypeChatProf },
                      on: {
                        click: function($event) {
                          return _vm.setUserType(_vm.PATIENT_ROLE)
                        }
                      }
                    },
                    [_c("span", [_vm._v(_vm._s(_vm.$t("chats.patients")))])]
                  ),
                  _c(
                    "base-button",
                    {
                      staticClass: "ml-1 d-flex justify-content-center",
                      staticStyle: { width: "50%" },
                      attrs: { white: !_vm.userTypeChatProf },
                      on: {
                        click: function($event) {
                          return _vm.setUserType(_vm.PROFESSIONAL_ROLE)
                        }
                      }
                    },
                    [
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("chats.professionals")))
                      ])
                    ]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", [
            _c(
              "ul",
              [
                _vm.$store.getters["session/userIsProfessional"]
                  ? _c(
                      "li",
                      {
                        staticClass: "chat-list-item",
                        on: {
                          click: function($event) {
                            return _vm.toggleShowDialog(
                              "showAdministrativeModal"
                            )
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "photo-name-wrapper" }, [
                          _c("div", { staticClass: "photo-align" }, [
                            _c("img", {
                              staticClass: "chat-list-photo chat-list-icon",
                              attrs: { src: _vm.defaultImg, alt: "" }
                            })
                          ]),
                          _vm._v(" "),
                          _vm.userTypeChatProf
                            ? _c("span", [
                                _vm._v(_vm._s(_vm.$t("chats.contact-prof")))
                              ])
                            : _c("span", [
                                _vm._v(_vm._s(_vm.$t("chats.contact-patient")))
                              ])
                        ])
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm._l(_vm.chatList, function(chat) {
                  return _c(
                    "li",
                    {
                      key: chat.idAppointment,
                      staticClass: "chat-list-item",
                      class: [_vm.chatUserDetails === chat ? "selected" : ""],
                      on: {
                        click: function($event) {
                          return _vm.selectChat(chat)
                        }
                      }
                    },
                    [
                      _c("div", { staticClass: "photo-name-wrapper" }, [
                        _c(
                          "div",
                          {
                            class: [!chat.createdByDoctor ? "photo-align" : ""]
                          },
                          [
                            _c("span", {
                              staticClass: "contact-status",
                              class: [
                                chat.conexionState === "online"
                                  ? "connected"
                                  : ""
                              ]
                            }),
                            _vm._v(" "),
                            _c("img", {
                              staticClass: "chat-list-photo",
                              attrs: { src: chat.urlPhoto, alt: "" }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "d-flex flex-column" },
                          [
                            _c("b-row", { staticClass: "chat-list-name" }, [
                              _c("span", [_vm._v(_vm._s(chat.name))])
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        chat.numMessagesPendingRead
                          ? _c("span", { staticClass: "unread-messages" }, [
                              _vm._v(_vm._s(chat.numMessagesPendingRead))
                            ])
                          : _vm._e()
                      ])
                    ]
                  )
                }),
                _vm._v(" "),
                _vm.chatIsPast
                  ? _c(
                      "li",
                      {
                        staticClass: "chat-list-item",
                        on: {
                          "~click": function($event) {
                            return _vm.$router.push("/patient/chats")
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "photo-name-wrapper" }, [
                          _vm._m(0),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(_vm.$t("chats.view-all")))])
                        ])
                      ]
                    )
                  : _c(
                      "li",
                      {
                        staticClass: "chat-list-item",
                        on: {
                          click: function($event) {
                            return _vm.getPastChats()
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "photo-name-wrapper" }, [
                          _vm._m(1),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("chats.finished-chats")))
                          ])
                        ])
                      ]
                    )
              ],
              2
            )
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.chatUserDetails
      ? _c("div", { staticClass: "chat-box chat-card" }, [
          _c(
            "div",
            { staticClass: "chat-header" },
            [
              _vm.$uiHelpers.isPortrait
                ? _c("b-icon-arrow-left", {
                    staticClass: "back-arrow",
                    staticStyle: { cursor: "pointer" },
                    on: {
                      click: function($event) {
                        return _vm.$store.commit("chat/unselectChat")
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("img", {
                staticClass: "photo",
                attrs: { src: _vm.chatUserDetails.urlPhoto, alt: "" }
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "user-info",
                  style: _vm.chatUserDetails.customPageUrl
                    ? "cursor: pointer;"
                    : "",
                  on: { click: _vm.goToProfPage }
                },
                [
                  _c("b-row", [
                    _c("p", { staticClass: "chat-name" }, [
                      _vm._v(_vm._s(_vm.chatUserDetails.name))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("b-row", [
                    _c("p", { staticClass: "chat-id" }, [
                      _vm._v("Id: " + _vm._s(_vm.chatUserDetails.idAppointment))
                    ])
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _vm.chatUserDetails.canCancel
                ? _c(
                    "div",
                    { staticClass: "cancel-consultation" },
                    [
                      _c(
                        "base-button",
                        {
                          attrs: { red: "", textColor: _vm.SECONDARY },
                          on: {
                            click: function($event) {
                              return _vm.$helpers.goToPatientWebApp(
                                "appointments/cancel/" +
                                  _vm.chatUserDetails.idAppointment,
                                _vm.$apiToken
                              )
                            }
                          }
                        },
                        [
                          _c("b-icon-x-circle"),
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("chats.cancel-chat")))
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              ref: "messageList",
              staticClass: "chat-content",
              on: {
                "&scroll": function($event) {
                  return _vm.showScrollBottomButtonHandler()
                }
              }
            },
            [
              _c(
                "ul",
                _vm._l(_vm.chatMessages, function(msg, index) {
                  return _c(
                    "li",
                    { key: msg.chatMessageId },
                    [
                      _vm.$store.state.chat.messagesPendingReadLabel > 0 &&
                      index === _vm.firstUnreadMessageIndex
                        ? _c("div", {
                            ref: "messagesPendingRead",
                            refInFor: true,
                            staticClass: "messages-pending-read"
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("chat-message", {
                        attrs: {
                          msg: msg,
                          userPhoto: _vm.chatUserDetails.urlPhoto
                        }
                      })
                    ],
                    1
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c("base-dialog", {
                attrs: {
                  content: _vm.$t("chats.finish-chat-message"),
                  okBtnText: _vm.$t("yes"),
                  cancelBtnText: _vm.$t("no"),
                  okFn: function() {
                    _vm.finishChatMessage()
                  },
                  cancelFn: function() {
                    _vm.$store.commit("chat/toggleShowDialog", "finish")
                  }
                },
                model: {
                  value: _vm.$store.state.chat.showDialog.finish,
                  callback: function($$v) {
                    _vm.$set(_vm.$store.state.chat.showDialog, "finish", $$v)
                  },
                  expression: "$store.state.chat.showDialog.finish"
                }
              }),
              _vm._v(" "),
              _c("base-dialog", {
                attrs: {
                  content: _vm.$t("chats.emit-eprescription-message"),
                  okBtnText: _vm.$t("continue"),
                  okFn: function() {
                    _vm.emitEPrescription()
                  },
                  cancelFn: function() {
                    _vm.$store.commit("chat/toggleShowDialog", "ePrescription")
                  }
                },
                model: {
                  value: _vm.$store.state.chat.showDialog.ePrescription,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.$store.state.chat.showDialog,
                      "ePrescription",
                      $$v
                    )
                  },
                  expression: "$store.state.chat.showDialog.ePrescription"
                }
              }),
              _vm._v(" "),
              _c("cancel-appointment-modal", {
                attrs: {
                  showDialog: _vm.showCancelModal,
                  appointmentId: _vm.chatUserDetails.idAppointment
                },
                on: {
                  toggleCancelAppointment: function($event) {
                    return _vm.toggleShowDialog("showCancelModal")
                  }
                }
              }),
              _vm._v(" "),
              _c("administrative-chat-modal", {
                attrs: {
                  showDialog: _vm.showAdministrativeModal,
                  userTypeChatProf: _vm.userTypeChatProf
                },
                on: {
                  toggleShowAdministrativeChat: function($event) {
                    return _vm.toggleShowDialog("showAdministrativeModal")
                  }
                }
              }),
              _vm._v(" "),
              _c("consolidate-appointment-modal", {
                attrs: {
                  value: _vm.showFinishModal,
                  isBillable:
                    _vm.chatUserDetails.showBillingSelectorOnConsolidate
                },
                on: { consolidate: _vm.consolidateChat }
              }),
              _vm._v(" "),
              _vm.showScrollBottomButton
                ? _c(
                    "button",
                    {
                      staticClass: "scroll-end-btn",
                      on: {
                        click: function($event) {
                          return _vm.$uiHelpers.scrollBottom(
                            _vm.$refs.messageList,
                            true
                          )
                        }
                      }
                    },
                    [_c("b-icon-arrow-down", { staticClass: "icon" })],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          !_vm.chatUserDetails.terminated
            ? _c(
                "div",
                { ref: "messageInput" },
                [
                  _c("chat-message-input"),
                  _vm._v(" "),
                  _vm.chatUserDetails.canFinish ||
                  _vm.chatUserDetails.ePrescriptionAvailable
                    ? _c(
                        "b-row",
                        { staticClass: "finish-consultation-options" },
                        [
                          _vm.chatUserDetails.ePrescriptionAvailable
                            ? _c(
                                "b-row",
                                {
                                  staticClass: "e-prescription",
                                  on: {
                                    click: function($event) {
                                      return _vm.$store.commit(
                                        "chat/toggleShowDialog",
                                        "ePrescription"
                                      )
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "p",
                                    [
                                      _c("b-icon-file-medical"),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("chats.emit-eprescription")
                                          )
                                        )
                                      ])
                                    ],
                                    1
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.chatUserDetails.canFinish
                            ? _c(
                                "b-row",
                                {
                                  staticClass: "finish-consultation",
                                  on: {
                                    click: function($event) {
                                      return _vm.$store.commit(
                                        "chat/toggleShowDialog",
                                        "finish"
                                      )
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "p",
                                    [
                                      _c("b-icon-telephone-x-fill"),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.$t("chats.finish-chat"))
                                        )
                                      ])
                                    ],
                                    1
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm.chatUserDetails.terminated && !_vm.chatUserDetails.reviewed
            ? _c(
                "div",
                { staticClass: " d-flex justify-content-center" },
                [
                  _c(
                    "base-button",
                    {
                      staticClass: "mb-3",
                      on: {
                        click: function($event) {
                          return _vm.$helpers.goToPatientWebApp(
                            "appointments/review/" +
                              _vm.chatUserDetails.idAppointment,
                            _vm.$apiToken
                          )
                        }
                      }
                    },
                    [
                      _c("b-icon-hand-thumbs-up-fill", { staticClass: "mr-2" }),
                      _c("span", [_vm._v(_vm._s(this.$t("review")))])
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ])
      : !_vm.chatsOpened
      ? _c(
          "div",
          {
            staticClass:
              "chat-box chat-card align-items-center justify-content-center"
          },
          [
            _c("span", [_vm._v(_vm._s(_vm.$t("chats.no-active-chat")))]),
            _vm._v(" "),
            _c(
              "base-button",
              {
                staticClass: "mt-2",
                on: {
                  click: function($event) {
                    return _vm.$router.push(
                      "/patient/search?appointmentType=" + _vm.CHAT
                    )
                  }
                }
              },
              [_c("span", [_vm._v(_vm._s(this.$t("chats.ask-for-new-chat")))])]
            ),
            _vm._v(" "),
            _vm.$uiHelpers.isPortrait
              ? _c(
                  "base-button",
                  {
                    staticClass: "mt-2",
                    on: {
                      click: function($event) {
                        return _vm.getPastChats()
                      }
                    }
                  },
                  [
                    _c("span", [
                      _vm._v(_vm._s(this.$t("chats.finished-chats")))
                    ])
                  ]
                )
              : _vm._e()
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "photo-align" }, [
      _c("img", {
        staticClass: "chat-list-photo chat-list-icon",
        attrs: {
          src:
            "/static-appopensalud/img/icons/morillas-svg-icons/primary/doc-icon-blue.svg",
          alt: ""
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "photo-align" }, [
      _c("img", {
        staticClass: "chat-list-photo chat-list-icon",
        attrs: {
          src:
            "/static-appopensalud/img/icons/morillas-svg-icons/primary/doc-icon-blue.svg",
          alt: ""
        }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-73c31155", esExports)
  }
}

/***/ })

});


// WEBPACK FOOTER //
// static-appopensalud/js/14.e054f21c9e12487c2693.js